import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { KeyRound } from "lucide-react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { confirmPasswordResetValidationForm } from "../../utils/validationSchema";
import Button from "../Reusable/Button";
import PasswordField from "../Reusable/Form/PasswordInput";
import TextField from "../Reusable/Form/TextInput";

const ConfirmPasswordReset = ({ handlePasswordReset }: any) => {
  const { handleSubmit, setError, control } = useForm<any>({
    resolver: yupResolver(confirmPasswordResetValidationForm),
  });
  const email = window.localStorage.getItem("email");

  return (
    <>
      <TextField
        label={"OTP"}
        icon={<KeyRound color="gray" strokeWidth={2} />}
        name="otp"
        control={control}
      />

      <p className={tw`w-full text-left text-xs text-primary`}>
        OTP was sent to {email}
      </p>

      <PasswordField
        label={"Password"}
        icon={<KeyRound color="gray" strokeWidth={2} />}
        name="password"
        control={control}
      />
      <PasswordField
        label={"Confirm Password"}
        icon={<KeyRound color="gray" strokeWidth={2} />}
        name="confirm_password"
        control={control}
      />
      <Button
        label={"Reset Password"}
        onClick={handleSubmit((data) => handlePasswordReset(data, setError))}
      />
      <div className={tw`w-full text-right px-4`}>
        <Link to="/">Back To Login</Link>
      </div>
    </>
  );
};

export default ConfirmPasswordReset;
